<template>
  <div>
    <MenuCount_Stock/>
    <Count_Create/>
  </div>
</template>

<script>
import MenuCount_Stock from "@/components/admin/count_stock/menucount_stock/MenuCount_Stock.vue";
import Count_Create from "@/components/admin/count_stock/Count_Create.vue";
export default {
  name: "CountCreate",
  components: {
    Count_Create,
    MenuCount_Stock
  }
}
</script>

<style scoped>

</style>
